<template>
  <Section>
    <div class="d-flex justify-center align-center">
      <div class="text-center" style="font-size: 24px;">Account Balance</div>
      <div class="text-center black--text ml-4" style="font-size: 32px;">
        {{ formatCurrency(me.balance_cents) }}
      </div>
    </div>
    <div v-if="isCurrent" class="d-flex justify-center mt-3">
      <square-button
        icon="mdi-rotate-3d-variant"
        :disabled="!me.default_payment_method"
        message="Manage Auto-Refill"
        @click="$router.push({ name: 'billing/auto_refill' })"
      />
      <square-button
        icon="mdi-cash-check"
        message="Add to Balance"
        class="ml-8"
        @click="$router.push({ name: 'billing/add_balance' })"
      />
    </div>
    <div v-if="isCurrent" class="text-center mt-4 mb-n2 font-italic" style="font-size: 14px;">Tip: Using auto refill can save you transaction fees.</div>
  </Section>
</template>

<script>
import { Section } from '@/components/pages'
import SquareButton from '../components/SquareButton'
import { mapGetters } from 'vuex'
import formatters from '@/lib/formatters'

export default {
  name: 'AccountBalanceSection',

  components: {
    Section,
    SquareButton,
  },

  computed: {
    ...mapGetters('auth', ['me']),

    isCurrent() {
      if (!this.me.membership_last_valid_time) {
        return true
      }

      const now = new Date()
      return now < new Date(this.me.membership_last_valid_time)
    }
  },

  methods: {
    ...formatters,
  },
}
</script>
